import { Button, Grid, Paper } from '@mui/material';
import { withStyles } from 'utils/styles';
import Divider from '@mui/material/Divider';
import InputAdornment from '@mui/material/InputAdornment';
import Typography from '@mui/material/Typography';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Alert from 'components/Alert';
import { cleanAlert } from 'ducks/alerts';
import reachOKLogo from 'images/brand/REACHok_branco.png';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { connect } from 'react-redux';
import theme from 'source/theme';
import styles from './styles';

const Component = props => {
  const { classes, alert } = props;
  const { cleanAlert } = props;
  const [email, setEmail] = useState('');

  const handleChangeEmail = event => {
    setEmail(event.target.value);
  };

  const handleSubmit = () => {
    //props.passwordForgot(email);
  };

  return (
    <div className={classes.container}>
      <div className={classes.loginArea}>
        <Paper className={classes.paper}>
          <div className={classes.margin}>
            <Alert
              open={alert.message.length !== 0}
              message={alert.message}
              handleClose={cleanAlert}
              placement={{ vertical: 'top', horizontal: 'right' }}
              variant={'error'}
            />

            <Grid sx={{ justifyContent: 'center' }} container>
              <Grid size={8}>
                <img src={reachOKLogo} style={{ width: '100%' }} alt=""/>
              </Grid>
            </Grid>

            <Divider style={{ marginBottom: '15px' }}/>

            <Grid sx={{ justifyContent: 'center' }} container spacing={8}>
              <Grid size={10}>
                <Typography
                  variant="h6" align='center' gutterBottom
                  style={{ color: theme.palette.secondary.dark }}
                >
                  Forgot password !
                </Typography>
                <Typography
                  variant="body2" align='justify' gutterBottom
                  style={{ color: theme.palette.secondary.dark }}
                >
                  Please insert the email for your account. You will receive an email breefly.
                  Thank you!
                </Typography>
              </Grid>
            </Grid>

            <Divider style={{ marginTop: '15px', marginBottom: '30px' }}/>

            <ValidatorForm onSubmit={handleSubmit}>
              <Grid container className={classes.textInput}>
                <Grid size="grow">
                  <TextValidator
                    // `variant` explicitly, because the theme's default
                    // does not reach here: the validator does
                    // `require('@mui/material/TextField')` - CommonJS - while
                    // the application imports the ESM build, and rspack bundles
                    // both. Each copy has its own defaults context, so the
                    // ThemeProvider fills one and this TextField reads the
                    // other, empty, and falls back to v5's `outlined`. v4's
                    // default was `standard`, an underline, which is what the
                    // login screen has always looked like.
                    variant="standard"
                    slotProps={{ input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <AccountCircle className={classes.iconColor} style={{ fontSize: 30 }}/>
                        </InputAdornment>
                      )
                    } }}
                    label="Email"
                    onChange={handleChangeEmail}
                    name="email"
                    value={email}
                    validators={['required', 'isEmail']}
                    errorMessages={['this field is required', 'email is not valid']}
                    fullWidth
                  />
                </Grid>
              </Grid>


              <Grid sx={{ justifyContent: 'center' }} container style={{ marginTop: '30px' }}>
                <Button
                  type="submit"
                  className={classes.textTransformationNone}
                  variant="contained"
                  color="secondary"
                >
                  Submit
                </Button>
              </Grid>
            </ValidatorForm>

          </div>
        </Paper>
      </div>
    </div>
  );
};

Component.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  alert: state.alert
});

const mapDispatchToProps = dispatch => ({
  // passwordForgot(user) {
  //   dispatch(passwordForgot(user));
  // },
  cleanAlert() {
    dispatch(cleanAlert());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Component));
